<template id="template-signature">
  <!-- :dir="$store.state.rightAlign ? 'rtl' : 'ltr'" -->

  <div :class="isPreview ? 'pb-2 mb-2' : 'bg-light p-3 pb-5 mb-2'">
    <!-- menu buttons -->
    <MenuButtons
      v-if="!isPreview"
      :fieldData="fieldData"
      :collapse="collapse"
      :sectionIndex="sectionIndex"
      :fieldIndex="fieldIndex"
      :label="fieldData.label[selectedLanguage]"
      v-on:toggle-field="showSettings=!showSettings"
      v-on:collapse-field="collapse=!collapse"
    />

    <b-collapse id="collapse-1" :class="isPreview ? 'mt-0 mb-4': 'mt-5 mb-4'" v-model="collapse">
      <b-row>
        <b-col cols="12" class="text-right">
          <b-button
            v-if="fieldData.isConditional=='1' && !isPreview"
            variant="outline-dark"
            disabled
            title="This field is hidden by default and will display bt is controlled element"
          >
            <font-awesome-icon icon="eye-slash" />
          </b-button>
        </b-col>
      </b-row>
      <div class="p-4 text-center">
        <div class="text-center" style="display: inline-flex;">
          <h3
            v-if="fieldData.signatureTitleTextIsDisabled == 0"
          >{{(form1.enableSectionFieldEnumeration == 1 ? (sectionIndex+1)+'.'+(fieldIndex+1) :'')}} {{fieldData.signatureTitle[selectedLanguage]}}</h3>
        </div>
        <!-- <span v-if="fieldData.validation.required && isFocus" class="text-danger">Required</span> -->
        <p
          v-if="fieldData.signatureDescriptionIsDisabled == 0"
          style="font: italic"
        >{{fieldData.signatureDescription[selectedLanguage]}}</p>
      </div>

      <b-form-checkbox
        :id="fieldData.id"
        :disabled="isDisabled == 1"
        v-if="fieldData.acceptTermsTextIsDisabled == 0"
        :class="$store.state.rightAlign ? 'text-right mb-3' : 'text-left mb-3'"
        v-model="acceptTermsText"
        name="checkbox-1"
        value="accepted"
        unchecked-value="not_accepted"
      >
        <span
          v-if="fieldData.validation && fieldData.validation.requiredTerms == 1"
          class="required-span"
        >*</span>
        {{fieldData.acceptTermsText[selectedLanguage]}}
      </b-form-checkbox>
      <p
        v-html="sanitizeHtml(fieldData.acceptTermsDescriptionText[selectedLanguage])"
        :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
      ></p>

      <p class="text-center" v-if="fieldData.signInTheAreaBelowLabelIsDisabled == 0">
        {{fieldData.signInTheAreaBelowLabel[selectedLanguage]}}
        <span
          v-if="fieldData.validation && fieldData.validation.required == 1"
          class="required-span"
        >*</span>
      </p>
      <!-- :disabled="isDisabled == 1" -->

      <!-- <b-img v-if="isDisabled == 1" :src="dataUrl" fluid></b-img> -->
      <!-- :w="'880px'"  this width is implemented because signature was having issue on prod server only -->
      <div id="122" :class="isDisabled == 1 ? 'isDisableSignature' : ''">
        <vueSignature
          ref="signature"
          :id="fieldData.id"
          :sigOption="option"
          :h="'250px'"
          :w="'880px'"
          :defaultUrl="dataUrl"
          style="border:1px dashed;"
        ></vueSignature>
      </div>

      <b-button-group class="mt-5">
        <b-button
          :disabled="isDisabled == 1"
          variant="info"
          @click="clear"
        >{{$t('signature.clear')}}</b-button>
      </b-button-group>

      <b-row v-if="fieldData.printNameLabelIsDisabled == 0">
        <b-col cols="12" class="text-left">
          <div :class="$store.state.rightAlign ? 'text-right' : 'text-left'">
            <label>{{fieldData.printNameLabel[selectedLanguage]}}</label>
            <span
              v-if="fieldData.validation && fieldData.validation.required == 1"
              class="required-span"
            >*</span>
          </div>
        </b-col>
      </b-row>

      <b-row v-if="fieldData.printNameLabelIsDisabled == 0">
        <b-col>

          <b-form-input
            :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
            :id="fieldData.id"
            :disabled="isDisabled == 1"
            type="text"
            v-model="signatureName"
            @blur="save"
            @input="setNameValue"
            :state="
              msg.xssName
                ? false
                : isFocus && fieldData.validation && fieldData.validation.requiredName == 1
                ? !$v.signatureName.required
                  ? false
                  : true
                : null
            "
            @focus="isFocus=true"
            :placeholder="fieldData.printNamePlaceholder[selectedLanguage]"
          ></b-form-input>
          <span
            v-if="fieldData.validation.requiredName && !$v.signatureName.required && isFocus"
            :class="$store.state.rightAlign ? 'float-right text-danger' : 'float-left text-danger'"
          >{{$t('createProfile.requiredValidationMessage')}}</span>
          <span
            v-if="msg.xssName"
            :class="$store.state.rightAlign ? 'float-right text-danger' : 'float-left text-danger'"
          >{{ $t('createProfile.invalidInputMessage') }}&nbsp;</span>
        </b-col>
      </b-row>

      <!-- new for company -->
      <b-row v-if="fieldData.companyFieldLabelIsDisabled == 0">
        <b-col cols="12" class="text-left">
          <div :class="$store.state.rightAlign ? 'text-right' : 'text-left'">
            <label>{{fieldData.printCompanyLabel[selectedLanguage]}}</label>
            <span
              v-if="fieldData.validation && fieldData.validation.requiredCompany == 1"
              class="required-span"
            >*</span>
          </div>
        </b-col>
      </b-row>

      <b-row v-if="fieldData.companyFieldLabelIsDisabled == 0">
        <b-col>
          <!-- :disabled="isDisabled == 1" -->

          <b-form-input
            :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
            :id="fieldData.id"
            :disabled="isDisabled == 1"
            type="text"
            v-model="signatureCompany"
            @blur="save"
            @input="setCompanyValue"
            :state="
              msg.xssCompany
                ? false
                : isFocus && fieldData.validation && fieldData.validation.requiredCompany == 1
                ? !$v.signatureCompany.required
                  ? false
                  : true
                : null
            "
            @focus="isFocus=true"
          ></b-form-input>
          <span
            v-if="fieldData.validation.requiredCompany == 1 && !$v.signatureCompany.required && isFocus"
            :class="$store.state.rightAlign ? 'float-right text-danger' : 'float-left text-danger'"
          >{{$t('createProfile.requiredValidationMessage')}}</span>
          <span
            v-if="msg.xssCompany"
            :class="$store.state.rightAlign ? 'float-right text-danger' : 'float-left text-danger'"
          >{{ $t('createProfile.invalidInputMessage') }}&nbsp;</span>
        </b-col>
      </b-row>

      <!-- new for place -->
      <b-row v-if="fieldData.placeFieldLabelIsDisabled == 0">
        <b-col cols="12" class="text-left">
          <div :class="$store.state.rightAlign ? 'text-right' : 'text-left'">
            <label>{{fieldData.printPlaceLabel[selectedLanguage]}}</label>
            <span
              v-if="fieldData.validation && fieldData.validation.requiredPlace == 1"
              class="required-span"
            >*</span>
          </div>
        </b-col>
      </b-row>

      <b-row v-if="fieldData.placeFieldLabelIsDisabled == 0">
        <b-col>
          <!-- :disabled="isDisabled == 1" -->

          <b-form-input
            :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
            :id="fieldData.id"
            :disabled="isDisabled == 1"
            type="text"
            v-model="signaturePlace"
            @blur="save"
            @input="setPlaceValue"
            :state="
              msg.xssPlace
                ? false
                : isFocus && fieldData.validation && fieldData.validation.requiredPlace == 1
                ? !$v.signaturePlace.required
                  ? false
                  : true
                : null
            "
            @focus="isFocus=true"
          ></b-form-input>
          <span
            v-if="fieldData.validation.requiredPlace == 1  && !$v.signaturePlace.required && isFocus"
            :class="$store.state.rightAlign ? 'float-right text-danger' : 'float-left text-danger'"
          >{{$t('createProfile.requiredValidationMessage')}}</span>
          <span
            v-if="msg.xssPlace"
            :class="$store.state.rightAlign ? 'float-right text-danger' : 'float-left text-danger'"
          >{{ $t('createProfile.invalidInputMessage') }}&nbsp;</span>
        </b-col>
      </b-row>

      <b-row v-if="fieldData.positionRoleLabelIsDisabled == 0">
        <b-col cols="12" class="text-left">
          <div :class="$store.state.rightAlign ? 'text-right' : 'text-left'">
            <label>{{fieldData.positionRoleLabel[selectedLanguage]}}</label>
            <span
              v-if="fieldData.validation && fieldData.validation.requirePositionRole == 1"
              class="required-span"
            >*</span>
          </div>
        </b-col>
      </b-row>

      <b-row v-if="fieldData.positionRoleLabelIsDisabled == 0">
        <b-col>
          <!-- :disabled="isDisabled == 1" -->

          <b-form-input
            :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
            :id="fieldData.id"
            :disabled="isDisabled == 1"
            type="text"
            v-model="positionRole"
            @blur="save"
            @input="setPostionRoleValue"
            :state="
              msg.xssPositionRole
                ? false
                : isFocus && fieldData.validation && fieldData.validation.requirePositionRole == 1
                ? !$v.positionRole.required
                  ? false
                  : true
                : null
            "
            @focus="isFocus=true"
            :placeholder="fieldData.positionRolePlaceholder[selectedLanguage]"
          ></b-form-input>
          <span
            v-if="fieldData.validation.requirePositionRole == 1 && !$v.positionRole.required && isFocus"
            :class="$store.state.rightAlign ? 'float-right text-danger' : 'float-left text-danger'"
          >{{$t('createProfile.requiredValidationMessage')}}</span>
          <span
            v-if="msg.xssPositionRole"
            :class="$store.state.rightAlign ? 'float-right text-danger' : 'float-left text-danger'"
          >{{ $t('createProfile.invalidInputMessage') }}&nbsp;</span>
        </b-col>
      </b-row>

      <b-row v-if="fieldData.dateFieldLabelIsDisabled == 0">
        <b-col cols="12" class="text-left">
          <div :class="$store.state.rightAlign ? 'text-right' : 'text-left'">
            <label>{{fieldData.dateFieldLabel[selectedLanguage]}}</label>
            <span
              v-if="fieldData.validation && fieldData.validation.requiredDate == 1"
              class="required-span"
            >*</span>
          </div>
        </b-col>
      </b-row>

      <div
        :class="$store.state.rightAlign ? 'text-right input-group mb-1' : 'text-left input-group mb-1'"
        v-if="fieldData.dateFieldLabelIsDisabled == 0"
      >
        <!-- :disabled="!isPreview || isDisabled == 1" -->
        <!-- input-class="custom-date-picker" -->
        <b-input-group-append v-if="$store.state.rightAlign">
          <span class="input-group-text" id="basic-addon2">
            <i class="fa fa-calendar"></i>
          </span>
        </b-input-group-append>
        <Datepicker
          :disabled="isDisabled == 1"
          calendar-class="date-calender"
          :input-class="$store.state.rightAlign ? 'custom-date-picker date-picker-right' : 'custom-date-picker date-picker-left' "
          class="form-control"
          v-model="signatureDate"
          @input="setDateValue"
          @blur="save"
          :format="customFormatter"
          :disabled-dates="disabledDates"
          @focus="isFocus=true"
        ></Datepicker>
        <b-input-group-append v-if="!$store.state.rightAlign">
          <span class="input-group-text" id="basic-addon2">
            <i class="fa fa-calendar"></i>
          </span>
        </b-input-group-append>

        <br />
      </div>
      <span
        v-if="fieldData.validation.requiredDate == 1 && !signatureDate && isFocus"
        :class="$store.state.rightAlign ? 'float-right text-danger' : 'float-left text-danger'"
      >{{$t('createProfile.requiredValidationMessage')}}</span>

      <!-- show advance field options -->
      <b-modal
        @hidden="onUpdateSettings"
        ok-title="Save"
        @ok="onSaveData"
        scrollable
        size="xl"
        v-model="showSettings"
        title="Signature Settings"
      >
        <SignatureSettings
          :fieldData="fieldData"
          :sectionIndex="sectionIndex"
          v-on:toggle-field="showSettings=!showSettings"
          :fieldIndex="fieldIndex"
        />
      </b-modal>
    </b-collapse>
  </div>
</template>

<script>
import SignatureSettings from "../advanceSignatureSettingsCompenent.vue";
import { required } from "vuelidate/lib/validators";
import MenuButtons from "../menuButtons";
import Datepicker from "vuejs-datepicker";
import { mapState, mapGetters, mapMutations } from "vuex";
import { Helper, Validate } from "../../helpers";
import { sanitizeHtml } from "@/utils/sanitizeHtml";
import { EventBus } from "@/event-bus.js";
import moment from "moment";
import "moment/locale/es";
import vueSignature from "vue-signature";

export default {
  name: "SignaturePad",
  components: {
    vueSignature,
    SignatureSettings,
    MenuButtons,
    Datepicker,
  },

  data() {
    return {
      isHidden: false,
      condition: {},
      showSettings: false,
      collapse: true,
      label: null,
      signature: null,
      signInTheAreaBelowLabel: null,
      signatureTitleText: null,
      signatureTitleTextIsDisabled: null,
      signatureDescriptionText: null,
      signatureDescriptionTextIsDisabled: null,
      acceptTermsText: null,
      acceptTermsTextIsDisabled: null,
      printNameLabel: null,
      printNameLabelIsDisabled: null,
      dateFieldLabelIsDisabled: null,
      positionRoleLabelIsDisabled: null,
      dateFieldLabel: null,
      dateFieldPlaceholder: null,
      signatureName: null,
      positionRole: null,
      signatureDate: null,
      signatureCompany: null,
      signaturePlace: null,
      isFocus: false,
      isError: false,
      isSuccess: false,
      postData: [],
      msg: {},

      //validation
      isRequired: 1,
      isRequiredName: 1,
      isRequiredPositionRole: 1,
      isRequiredDate: 1,
      isRequiredTerms: 1,
      isRequiredCompany: 1,
      isRequiredPlace: 1,

      // Signature pad options
      option: {
        penColor: "rgb(0, 0, 0)",
        backgroundColor: "rgb(255,255,255)",
      },
      dataUrl: "",
      disabledDates: {
        to:
          this.fieldData.advance && this.fieldData.advance.disabledMinDateInput
            ? new Date(Date.now() - 864e5)
            : this.fieldData.advance && this.fieldData.advance.minDate
            ? new Date(this.fieldData.advance.minDate)
            : "", // Disable all dates up to specific date
        from:
          this.fieldData.advance && this.fieldData.advance.disabledMaxDateInput
            ? new Date()
            : this.fieldData.advance && this.fieldData.advance.maxDate
            ? new Date(this.fieldData.advance.maxDate)
            : "", // Disable all dates after specific date
      },
    };
  },
  computed: {
    ...mapGetters(["form1", "selectedLanguage"]),
    ...mapState(["toggleAllCoppalse", "userFormSubmitArray"]),
  },
  created() {
    EventBus.$on("onSubmitEndUserForm", (value) => {
      if (this.hasActiveXssError()) {
        this.isFocus = true;
        this.$store.state.validFields = false;
        this.fieldData.isInValid = true;
        return;
      }
      if (value == "progress") {
        this.stTempData();
      } else {
        this.save();
        if (
          this.fieldData.validation.required == 1 ||
          this.fieldData.validation.requiredName == 1 ||
          this.fieldData.validation.requirePositionRole == 1 ||
          this.fieldData.validation.requiredDate == 1 ||
          this.fieldData.validation.requiredTerms == 1 ||
          this.fieldData.validation.requiredCompany == 1 ||
          this.fieldData.validation.requiredPlace == 1
        ) {
          if (
            this.fieldData.validation.requiredTerms == 1 &&
            !this.acceptTermsText
          ) {
            this.$store.state.validFields = false;
            this.fieldData.isInValid = true;
            this.isFocus = true;
          } else if (
            this.fieldData.validation.requiredDate == 1 &&
            !this.signatureDate
          ) {
            this.$store.state.validFields = false;
            this.fieldData.isInValid = true;
            this.isFocus = true;
          } else if (
            this.fieldData.validation.required == 1 &&
            !this.signature
          ) {
            this.$store.state.validFields = false;
            this.fieldData.isInValid = true;
            this.isFocus = true;
          } else if (
            this.fieldData.validation.requirePositionRole == 1 &&
            !this.positionRole
          ) {
            this.$store.state.validFields = false;
            this.fieldData.isInValid = true;
            this.isFocus = true;
          } else if (
            this.fieldData.validation.requiredName == 1 &&
            !this.signatureName
          ) {
            this.$store.state.validFields = false;
            this.fieldData.isInValid = true;
            this.isFocus = true;
          } else if (
            this.fieldData.validation.requiredCompany == 1 &&
            !this.signatureCompany
          ) {
            this.$store.state.validFields = false;
            this.fieldData.isInValid = true;
            this.isFocus = true;
          } else if (
            this.fieldData.validation.requiredPlace == 1 &&
            !this.signaturePlace
          ) {
            this.$store.state.validFields = false;
            this.fieldData.isInValid = true;
            this.isFocus = true;
          } else {
            this.$store.state.validFields = true;
            this.fieldData.isInValid = false;

            this.stTempData();
          }
        }
      }
    });

    EventBus.$on("OnInvalidFieldCatch", (inValidData) => {
      document
        .getElementById(inValidData.elementId)
        .scrollIntoView({ behavior: "smooth" });
    });
  },

  mounted() {
    let self = this;
    this.isRequired = this.fieldData.validation.required;
    this.isRequiredName = this.fieldData.validation.requiredName;
    this.isrequiredPositionRole = this.fieldData.validation.requiredPositionRole;
    this.isRequiredDate = this.fieldData.validation.requiredDate;
    this.isRequiredTerms = this.fieldData.validation.requiredTerms;
    this.dataUrl =
      (this.fieldData.data && this.fieldData.data.signatureValue) || "";
    if (
      this.$route.name == "userform" ||
      this.$route.name == "userTraining" ||
      this.$route.name == "mytpptraining" ||
      this.$route.name == "EmployeeUserTrainingPage" ||
      this.$route.name == "EmployeeUserFormPage"||
      this.$route.name == "EmployeeUserTrainingPDF"
    ) {
      if(this.$route.name == "EmployeeUserTrainingPage"){
        this.setUserFullName();
      }
      this.getDataForUser();
    }
    this.addNewFileds();
    document.getElementById("122").addEventListener("click", function () {
      self.save();
    });
  },

  validations: {
    signatureName: {
      required,
    },
    positionRole: {
      required,
    },
    signatureCompany: {
      required,
    },
    signaturePlace: {
      required,
    },
  },

  watch: {
    toggleAllCoppalse(vlue) {
      this.collapse = vlue;
    },
  },

  methods: {
    sanitizeHtml,
    ...mapMutations(["TOGGLE_LOADER"]),
    setUserFullName(){
      let datail = JSON.parse(localStorage.getItem("userDetail"));
      let nameToShow = datail.first_name + " " + datail.last_name;
      if(this.fieldData.printNameLabelIsDisabled == 0){
        this.setNameValue(nameToShow);
      }
    },

    onUpdateSettings() {
      this.TOGGLE_LOADER(2);
    },

    addNewFileds() {
      Object.assign(this.fieldData, {
        companyFieldLabelIsDisabled:
          this.fieldData.companyFieldLabelIsDisabled || 0,
      });
      Object.assign(this.fieldData, {
        placeFieldLabelIsDisabled:
          this.fieldData.placeFieldLabelIsDisabled || 0,
      });

      Object.assign(this.fieldData, {
        printCompanyLabel: this.fieldData.printCompanyLabel || {
          english: "Company",
        },
      });
      Object.assign(this.fieldData, {
        printPlaceLabel: this.fieldData.printPlaceLabel || { english: "Place" },
      });
    },

    setValue() {
      const registerData = _.clone(this.$store.state.registerData);

      if (
        this.$route.name == "userform" ||
        this.$route.name == "userTraining" ||
        this.$route.name == "EmployeeUserTrainingPage" ||
        this.$route.name == "EmployeeUserFormPage"||
        this.$route.name == "EmployeeUserTrainingPDF"
      ) {
        if (!this.$v.$invalid) {
          registerData[this.fieldData.id] = "signature";
        } else {
          delete registerData[this.fieldData.id];
        }
        this.$store.state.registerData = registerData;

        // main calculations :p
        const numkeys = Object.keys(registerData).length;
        // const sectionLength = this.form1.formSection.length > 1 ? this.form1.formSection[this.sectionIndex].formElements.length : 1
        this.$store.state.progressValue = numkeys;

        let data = {
          acceptTermsText: this.acceptTermsText,
          signatureValue: this.signature,
          nameValue: this.signatureName,
          positionRoleValue: this.positionRole,
          dateValue: this.signatureDate,
          companyValue: this.companyValue,
          placeValue: this.placeValue,
        };
        Object.assign(this.fieldData, { data });
      }
      // this.setDataToUser();
    },

    checkXss(key, value) {
      this.msg[key] = !Validate.noXSS(value) ? true : false;
    },

    hasActiveXssError() {
      return Object.keys(this.msg).some((key) => key.startsWith("xss") && this.msg[key]);
    },

    setNameValue(e) {
      this.signatureName = e;
      this.checkXss("xssName", e);
      if (!this.$v.$invalid) {
        this.setValue();
      }
    },

    setCompanyValue(e) {
      this.signatureCompany = e;
      this.checkXss("xssCompany", e);
      if (!this.$v.$invalid) {
        this.setValue();
      }
    },

    setPlaceValue(e) {
      this.signaturePlace = e;
      this.checkXss("xssPlace", e);
      if (!this.$v.$invalid) {
        this.setValue();
      }
    },

    setPostionRoleValue(e) {
      this.positionRole = e;
      this.checkXss("xssPositionRole", e);
      if (!this.$v.$invalid) {
        this.setValue();
      }
    },

    setDateValue(e) {
      this.signatureDate = e;
      if (!this.$v.$invalid) {
        this.setValue();
      }
    },

    getDataForUser() {
      this.$store.state.getUserFormSubmitArray.map((data) => {
        if (data.elements && data.elements.length > 0) {
          data.elements.map((element, index) => {
            if (data.elementId === this.fieldData.id) {
              this.acceptTermsText =
                element[
                  element.findIndex((x) => x.key == "acceptTermsText")
                ].postValue;
              this.signatureName =
                element[
                  element.findIndex((x) => x.key == "nameValue")
                ].postValue;
              this.positionRole =
                element[
                  element.findIndex((x) => x.key == "positionRoleValue")
                ].postValue;
              this.signatureDate =
                element[
                  element.findIndex((x) => x.key == "dateValue")
                ].postValue;
              this.signature =
                element[
                  element.findIndex((x) => x.key == "signatureValue")
                ].postValue;
              this.signatureCompany =
                element[
                  element.findIndex((x) => x.key == "companyValue")
                ].postValue;
              this.signaturePlace =
                element[
                  element.findIndex((x) => x.key == "placeValue")
                ].postValue;
              this.dataUrl =
                element[
                  element.findIndex((x) => x.key == "signatureValue")
                ].postValue;
            }
          });
        }
      });
    },

    stTempData() {
      if (
        this.$route.name == "userform" ||
        this.$route.name == "userTraining" ||
        this.$route.name == "EmployeeUserTrainingPage" ||
        this.$route.name == "EmployeeUserFormPage"||
        this.$route.name == "EmployeeUserTrainingPDF"
      ) {
        this.postData = [];

        let aa = [
          {
            postValue: this.acceptTermsText,
            postNameTerms: "acceptTerms",
            key: "acceptTermsText",
            label: this.fieldData.acceptTermsText[this.selectedLanguage],
          },
          {
            postValue: this.fieldData.acceptTermsDescriptionText[
              this.selectedLanguage
            ],
            postNameTerms: "information",
            key: "informationText",
            label: this.fieldData.acceptTermsDescriptionText[
              this.selectedLanguage
            ],
          },
          {
            postValue: this.fieldData.data.signatureValue || this.signature,
            postNameSignature:
              (this.fieldData.attributes &&
                this.fieldData.attributes.postNameSignature) ||
              "postNameSignature",
            key: "signatureValue",
            label: this.fieldData.signInTheAreaBelowLabel[
              this.selectedLanguage
            ],
          },
          {
            postValue: this.msg.xssName
              ? ""
              : this.fieldData.data.nameValue || this.signatureName,
            postNameName:
              (this.fieldData.attributes &&
                this.fieldData.attributes.postNameName) ||
              "postNameName",
            key: "nameValue",
            label: this.fieldData.printNameLabel[this.selectedLanguage],
          },
          {
            postValue: this.msg.xssPositionRole
              ? ""
              : this.fieldData.data.positionRoleValue || this.positionRole,
            postNamePositionRole:
              (this.fieldData.attributes &&
                this.fieldData.attributes.postNamePositionRole) ||
              "postNamePositionRole",
            key: "positionRoleValue",
            label: this.fieldData.positionRoleLabel[this.selectedLanguage],
          },
          {
            postValue: this.fieldData.data.dateValue || this.signatureDate,
            postNameDate:
              (this.fieldData.attributes &&
                this.fieldData.attributes.postNameDate) ||
              "postNameDate",
            key: "dateValue",
            label: this.fieldData.dateFieldLabel[this.selectedLanguage],
          },
          {
            postValue: this.msg.xssCompany
              ? ""
              : this.fieldData.data.companyValue || this.signatureCompany,
            postNameCompany: "postNameCompany",
            key: "companyValue",
            label: this.fieldData.printCompanyLabel[this.selectedLanguage],
          },
          {
            postValue: this.msg.xssPlace
              ? ""
              : this.fieldData.data.placeValue || this.signaturePlace,
            postNamePlace: "postNamePlace",
            key: "placeValue",
            label: this.fieldData.printPlaceLabel[this.selectedLanguage],
          },
        ];

        this.postData.push(aa);
        this.setDataToUser();
      }
    },

    setDataToUser() {
      if (
        this.$route.name == "userform" ||
        this.$route.name == "userTraining" ||
        this.$route.name == "EmployeeUserTrainingPage" ||
        this.$route.name == "EmployeeUserFormPage" ||
        this.$route.name == "EmployeeUserTrainingPDF"
      ) {
        this.$store.state.userFormSubmitArray.map((a, index) => {
          if (a.elementId === this.fieldData.id) {
            a.elements = this.postData;
            a.disableTitle = this.fieldData.signatureTitleTextIsDisabled;
          }
        });
      }
    },

    save() {
      if (!this.$refs.signature.isEmpty()) {
        let png = this.$refs.signature.save();
        let jpeg = this.$refs.signature.save("image/jpeg");
        let svg = this.$refs.signature.save("image/svg+xml");
        this.signature = png;
        this.dataUrl = png;
        this.setValue(png);
      }
      // console.log("this.signature this.signature this.signature",this.signature);
    },

    clear() {
      this.$refs.signature.clear();
      this.signature = null;
      this.dataUrl = "";
    },

    addWaterMark() {
      var _this = this;
      _this.$refs.signature.addWaterMark({
        text: "mark text", // watermark text, > default ''
        font: "20px Arial", // mark font, > default '20px sans-serif'
        style: "all", // fillText and strokeText,  'all'/'stroke'/'fill', > default 'fill
        fillStyle: "red", // fillcolor, > default '#333'
        strokeStyle: "blue", // strokecolor, > default '#333'
        x: 100, // fill positionX, > default 20
        y: 200, // fill positionY, > default 20
        sx: 100, // stroke positionX, > default 40
        sy: 200, // stroke positionY, > default 40
      });
    },

    fromDataURL(url) {
      var _this = this;
      _this.$refs.signature.fromDataURL("data:image/png;base64,iVBORw0K...");
    },

    handleDisabled() {
      var _this = this;
      _this.disabled = !_this.disabled;
    },

    onSaveData() {
      EventBus.$emit("onSaveSettings", "saving settings");
      Helper.makeToast(this.$bvToast, "success", "Settings updated");
    },

    makeToast(variant = null, message) {
      this.$bvToast.toast(message, {
        title: this.$t("toast.title"),
        variant: variant,
        solid: true,
      });
    },

    customFormatter(date) {
      let customFormat = this.fieldData.format;
      if (customFormat == "default") {
        return moment(date).format("DD-MM-YYYY");
      } else {
        return moment(date).format(customFormat);
      }
    },
  },

  props: {
    fieldData: Object,
    isPreview: Boolean,
    sectionIndex: Number,
    fieldIndex: Number,
    isDisabled: Number,
  },
};
</script>
<style>
.custom-date-picker {
  width: 100%;
  border: none;
}
.date-picker-right {
  text-align: right !important;
}
.date-picker-left {
  text-align: left !important;
}
.input-group-text-left {
  border-top-right-radius: 2px !important;
  border-bottom-right-radius: 2px !important;
}
.custom-date-picker:focus {
  border: none;
}
.isDisableSignature {
  pointer-events: none;
}
</style>
